enum EFileType {
  XLS = "xls",
  XLSX = "xlsx",
}

export default EFileType;
